import Vue from 'vue';
import { client } from '@/store';

export default {
	namespaced: true,

	state: {
		files: []
	},

	// sync actions
	mutations: {
		setFilesData(state, value) {
			state.files = value;
		}
	},

	actions: {
		fetchFiles({ commit, state, dispatch }, data) {
			const query = `
				query($type: String!, $company_id: ID!) {
					getFiles(type: $type, company_id: $company_id) {
						id
						company_id
						file_name
						type
						upload_date
						size
					}
				}
			`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, {...data}).then(result => {
					commit('setIdle', null, { root: true });
					commit('setFilesData', result.getFiles);
					resolve(result.getFiles);
				}).catch(error => {
					commit('setIdle', null, { root: true });
					reject(error);
				});
			});
		},
		deleteFile({ commit, state, dispatch }, data) {
			const mutation = `
				mutation($id: ID!) {
					deleteFile(file_id: $id)
				}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(mutation, {...data}).then(result => {
					commit('setIdle', null, { root: true });
					resolve(true);
				}).catch(error => {
					commit('setIdle', null, { root: true });
					reject(error);
				});
			});
		},
		deleteFileByType({ commit, state, dispatch }, data) {
			const mutation = `
				mutation($type: String, $company_id: ID!) {
					deleteFilesByType(type: $type, company_id: $company_id)
				}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(mutation, {...data}).then(result => {
					commit('setIdle', null, { root: true });
					resolve(true);
				}).catch(error => {
					commit('setIdle', null, { root: true });
					reject(error);
				});
			});
		}
	}
};
